import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import download from 'downloadjs';
import Flag from 'react-country-flag';
import ReactTable from "react-table";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import filesize from 'filesize';

import _ from 'underscore';

import "react-table/react-table.css";
import 'bootstrap-daterangepicker/daterangepicker.css';

import {
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ButtonGroup,
  Col,
  Row
} from 'reactstrap';
import Dialog from 'react-bootstrap-dialog';

import { updateAdminSamplesPageSize,
  updateAdminSamplesTablePage,
  updateAdminSamplesFilters,
  updateAdminSamplesSorting } from '../../actions/sandbox';
import DBadge from '../../components/Badge';
import PlatformStatus from '../../components/PlatformStatus';
import ResultRuleCounter from '../../components/ResultRuleCounter';

import { localizeDate } from '../../utils/dates';
import { submissionStatus,
  submissionResults,
  supportedFormats,
  supportedExtensions,
  cleanStatus,
  maliciousStatus,
  unsupportedStatus } from '../../constants/submissions';
import { platformStatus, maxTableElements } from '../../constants/sandbox';
import { OSnames } from '../../constants/names';
import { adminGroup, qaGroup } from '../../constants/users';
import { statusProcessing, analysisCompleted, analysisFailed } from '../../constants/api';
import { fetchSamplesList, fetchSampleSubmissionsList } from '../../services/submissions';
import { fetchSample } from '../../services/download';
import { sendRescan, fixClassification } from '../../services/sandbox';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload,
  faSlidersH,
  faRedo,
  faUserAstronaut,
  faUserTie,
  faUserMd,
  faLaptopCode,
  faUserCheck,
  faMailBulk,
  faTable,
  faListOl
} from '@fortawesome/free-solid-svg-icons';

import { faUser, faCalendar } from '@fortawesome/free-regular-svg-icons';

import { statusSuccess } from '../../constants/api';
import { handleError } from '../../services/errorHandler';

import style from './style.scss';

const deepvizLogo = require('../../../images/deepviz-logo.png');

class SandboxSamples extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pages: null,
      loading: false,
      extraSearch: {
        currentKey: '',
        currentValue: ''
      },
      modalFixClassification: {
        visible: false,
        tempFixed: null,
        tempClassification: null,
        sha512: null,
        rescanAfterFixedClassification: false
      },
      modalSampleSubmissionsList: {
        visible: false,
        hash: null,
        data: [],
        pages: null,
        loading: false
      },
      currentExtra: {
        visible: false,
        data: null
      }
    };

    this.platformFilter = React.createRef();
    this.platformResult = React.createRef();
    this.formatFilter = React.createRef();
    this.extensionFilter = React.createRef();
    this.table = React.createRef();
  }

  fetchData = parameters => {
    const { extraSearch } = this.state;
    const { page, pageSize, sorted, filtered } = parameters;
    const { updateAdminSamplesPageSize,
      updateAdminSamplesTablePage,
      updateAdminSamplesFilters,
      updateAdminSamplesSorting } = this.props;
    const { adminSamplesPageSize } = this.props.sandbox;

    updateAdminSamplesTablePage(page + 1);
    updateAdminSamplesFilters(filtered);
    updateAdminSamplesSorting(sorted);

    if(adminSamplesPageSize !== pageSize)
      updateAdminSamplesPageSize(pageSize);

    this.setState({ loading: true });

    fetchSamplesList(
      pageSize,
      page + 1,
      sorted,
      filtered,
      extraSearch
    ).then(res => {
      if(res.status === statusSuccess) {
        if (res.data.total > maxTableElements)
          res.data.total = maxTableElements;

        this.setState({
          data: res.data.rows,
          pages: Math.ceil(res.data.total / pageSize),
        });
      } else {
        handleError('error', 'Error retrieving submission data');
      }
    }).catch(() => {
      this.setState({
        data: [],
        pages: 1
      });
    }).finally(() => {
      this.setState({
        loading: false
      })
    });
  }

  fetchSampleSubmissionsListData = () => {
    const { hash } = this.state.modalSampleSubmissionsList;
    
    this.setState(oldState => {
      return {
        modalSampleSubmissionsList: {
          ...oldState.modalSampleSubmissionsList,
          loading: true
        }
      }
    });

    fetchSampleSubmissionsList(hash).then(res => {
      if(res.status === statusSuccess) {
        this.setState(oldState => {
          return {
            modalSampleSubmissionsList: {
              ...oldState.modalSampleSubmissionsList,
              data: res.data.rows
            }
          }
        });
      } else {
        handleError('error', 'Error retrieving sample submissions list');
      }
    }).catch(() => {
      this.setState(oldState => {
        return {
          modalSampleSubmissionsList: {
            ...oldState.modalSampleSubmissionsList,
            data: []
          }
        }
      });
    }).finally(() => {
      this.setState(oldState => {
        return {
          modalSampleSubmissionsList: {
            ...oldState.modalSampleSubmissionsList,
            loading: false
          }
        }
      });
    });
  }

  printGroup(group) {
    switch(group) {
      case 'edr': 
        return <FontAwesomeIcon icon={faLaptopCode} className={style.groupIcon} title="Submission from EDR" />;
      case 'cosmos':
          return <FontAwesomeIcon icon={faUserAstronaut} className={style.groupIcon} title="Submission from Cosmos" />;
      case 'admin':
          return <FontAwesomeIcon icon={faUserTie} className={style.groupIcon} title="Submission from Admin" />;
      case 'research':
          return <FontAwesomeIcon icon={faUserMd} className={style.groupIcon} title="Submission from Research" />;
      case 'sbx':
          return <img src={deepvizLogo.default} className={style.groupIcon} alt="Submission from Sbx" title="Submission from Sbx" />;
      case 'qa':
          return <FontAwesomeIcon icon={faUserCheck} className={style.groupIcon} title="Submission from QA" />;
      case 'mbet':
          return <FontAwesomeIcon icon={faMailBulk} className={style.groupIcon} title="Submission from MBET" />;
      default:
        return <FontAwesomeIcon icon={faUser} className={style.groupIcon} title="Submission from User" />;
    }
  }

  downloadSample = hash => {
    fetchSample(hash).then(response => {
      return response.blob();
    }).then(myBlob => {
      return download(myBlob, `${hash}.deepviz`, 'application/octet-stream');
    })
  }

  startRescan = hash => {
    this.dialog.show({
      title: 'Rescan',
      body: 'Do you want to start a rescan?',
      actions: [
        Dialog.CancelAction(),
        Dialog.Action(
          'Confirm',
          () => {
            sendRescan(hash).then(res => {
              if(res.status === statusSuccess) {
                handleError('Success', 'Rescan sent', 'success', () => {
                  this.setState(state => {
                    const newData = state.data.map(row => {
                      if(row.md5 !== hash) {
                        return row;
                      } else {
                        return {
                          ...row,
                          status: 'pending',
                          dynamic_analyses: [],
                          result: null
                        }
                      }
                    })
                    return {
                    data: newData
                  }});
                });
              } else if (res.status === statusProcessing) {
                handleError('Warning', 'Sample already in processing', 'warning');
              } else {
                handleError('Error', 'Error starting rescan');
              }
            }).finally(() => {
              this.setState({
                rescanInProgress: false
              });
            })
          },
          'btn-primary'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  }

  toggleFixClassification = e => {
    if(e) e.preventDefault();
    const { modalFixClassification } = this.state;
    this.setState({
      modalFixClassification: {
        visible: !modalFixClassification.visible,
        tempFixed: false,
        tempClassification: false,
        sha512: null,
        rescanAfterFixedClassification: false
      }
    });
  }

  toggleSampleSubmissionsList = e => {
    if(e) e.preventDefault();
    const { modalSampleSubmissionsList } = this.state;
    this.setState({
      modalSampleSubmissionsList: {
        ...modalSampleSubmissionsList,
        visible: !modalSampleSubmissionsList.visible
      }
    });
  }

  renderExtraInfo = () => {
    const { visible, data } = this.state.currentExtra;

    return (
      <Modal isOpen={visible} toggle={this.toggleExtraInfo} size="lg" style={{marginTop: '50px', maxWidth: '1200px', width: '80%', overflowX: 'auto'}}>
        <ModalHeader toggle={this.toggleExtraInfo}>Extra information</ModalHeader>
        <ModalBody>
          {data && Object.entries(data).map((e, i) => <p className={style.extraInfo} key={i}>{e[0]}: {e[1]}</p>)}
        </ModalBody>
      </Modal>
    );
  }

  renderFixClassificationModal = () => {
    const { visible, tempFixed, tempClassification, rescanAfterFixedClassification } = this.state.modalFixClassification;

    return (
      <Modal isOpen={visible} toggle={this.toggleFixClassification}>
        <ModalHeader toggle={this.toggleFixClassification}>Fixed classification</ModalHeader>
        <ModalBody>
          <p className='mb-0'>Fixed classification:</p>
          <ButtonGroup className='mb-3'>
            <Button size="sm" color={tempFixed ? 'primary' : 'secondary'} onClick={() => this.changeTempFixed(true)} active={tempFixed}>YES</Button>
            <Button size="sm" color={!tempFixed ? 'primary' : 'secondary'} onClick={() => this.changeTempFixed(false)} active={!tempFixed}>NO</Button>
          </ButtonGroup>
          <p className='mb-0'>Classification result:</p>
          <ButtonGroup className='mb-3'>
            <Button size="sm" color={tempClassification === cleanStatus ? 'success' : 'secondary'} onClick={() => this.changetempClassification(cleanStatus)} active={tempClassification === cleanStatus}>Clean</Button>
            <Button size="sm" color={tempClassification === maliciousStatus ? 'danger' : 'secondary'} onClick={() => this.changetempClassification(maliciousStatus)} active={tempClassification === maliciousStatus}>Malicious</Button>
          </ButtonGroup>
          <p className='mb-0'>Rescan the sample:</p>
          <ButtonGroup>
            <Button size="sm" color={rescanAfterFixedClassification === true ? 'success' : 'secondary'} onClick={() => this.changeRescanAfterFixedClassification(true)} active={rescanAfterFixedClassification}>Yes</Button>
            <Button size="sm" color={rescanAfterFixedClassification === false ? 'danger' : 'secondary'} onClick={() => this.changeRescanAfterFixedClassification(false)} active={!rescanAfterFixedClassification}>No</Button>
          </ButtonGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.sendFixClassification}>Send</Button>
        </ModalFooter>
      </Modal>
    );
  }

  renderSampleSubmissionsList = () => {
    const {
      visible,
      data,
      hash,
      loading
    } = this.state.modalSampleSubmissionsList;

    return (
      <Modal isOpen={visible} toggle={this.toggleSampleSubmissionsList} size="lg" style={{maxWidth: '1600px', width: '90%'}}>
        <ModalHeader toggle={this.toggleSampleSubmissionsList}>Submissions List</ModalHeader>
        <ModalBody>
        <ReactTable
        columns={[
          {
            Header: "Email",
            id: "email",
            accessor: d => <Link to={`/admin/submissions/${d.user_id}/`}>{d.email}</Link>
          },
          {
            Header: "Group",
            id: "group",
            accessor: d => this.printGroup(d.group),
            className: 'centeredCell',
            maxWidth: 55,
            sortable: false,
            filterable: false,
            resizable: false
          },
          {
            Header: "Filename",
            id: "file_name",
            accessor: d => <Link to={`/sandbox/report/${hash}/`}>{d.file_name}</Link>
          },
          {
            Header: "Submission date",
            id: "date",
            minWidth: 150,
            maxWidth: 150,
            accessor: d => localizeDate(d.timestamp)
          },
          {
            Header: "IP",
            id: "ip",
            minWidth: 120,
            maxWidth: 120,
            accessor: d => d.ip
          },
          {
            Header: "Country",
            id: "country",
            className: 'centeredCell',
            minWidth: 65,
            maxWidth: 65,
            accessor: d => <Flag code={d.geo_info.country_code} title={d.geo_info.country_name} svg styleProps={{
              fontSize: '16px'
          }}/>
          },
          {
            Header: "Extra",
            id: "extra",
            className: 'centeredCell',
            minWidth: 65,
            maxWidth: 65,
            accessor: d => !_.isEmpty(d.extra) && <FontAwesomeIcon
              icon={faTable}
              className={style.extraIcon}
              title="Extra info"
              onClick={() => this.showExtraInfo(Buffer.from(JSON.stringify(d.extra)).toString("base64"))}
            />
          }
        ]}
        manual
        minRows="1"
        data={data}
        loading={loading}
        onFetchData={this.fetchSampleSubmissionsListData}
        className="-striped -highlight"
        sortable={false}
        filterable={false}
        showPagination={false}
      />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.toggleSampleSubmissionsList}>Close</Button>
        </ModalFooter>
      </Modal>
    );
  }

  showExtraInfo = info => {
    this.setState({
      currentExtra: {
        visible: true,
        data: JSON.parse(atob(info))
      }
    });
  }

  toggleExtraInfo = e => {
    if(e) e.preventDefault();
    const { currentExtra } = this.state;

    this.setState({
      currentExtra: {
        visible: !currentExtra.visible,
        data: null
      }
    });
  }

  changeTempFixed = tempFixed => {
    const { modalFixClassification } = this.state;
    this.setState({
       modalFixClassification: {
        ...modalFixClassification,
        tempFixed
      }
    })
  }

  changetempClassification = tempClassification => {
    const { modalFixClassification } = this.state;
    this.setState({
       modalFixClassification: {
        ...modalFixClassification,
        tempClassification
      }
    })
  }

  changeRescanAfterFixedClassification = rescan => {
    const { modalFixClassification } = this.state;
    this.setState({
       modalFixClassification: {
        ...modalFixClassification,
        rescanAfterFixedClassification: rescan
      }
    })
  }

  sendFixClassification = () => {
    const { modalFixClassification } = this.state;
    const { tempFixed, tempClassification, rescanAfterFixedClassification, sha512 } = this.state.modalFixClassification;

    this.setState({
      modalFixClassification: {
        ...modalFixClassification,
        visible: false
      }
    }, () => {
      fixClassification(sha512, tempFixed, tempClassification, rescanAfterFixedClassification).then(res => {
        if(res.status === statusSuccess) {
          handleError('Success', 'Classification set', 'success', () => {
            this.setState(state => {
              const newData = state.data.map(row => {
                if(row.sha512 !== sha512) {
                  return row;
                } else {

                  if(rescanAfterFixedClassification) {
                    return {
                      ...row,
                      status: 'pending'
                    }
                  } else {
                    return {
                      ...row,
                      result: tempClassification,
                      fixed_classification: tempClassification
                    }                      
                  }
                }
              })
              return {
              data: newData
            }})
          });
        } else {
          handleError('Error', 'Error setting classification');
        }
      })
    });
  }

  checkInput = event => {
    if(event.key === 'Enter'){
      this.updateTable();
    }
  }

  updateInputCurrentKey(evt) {
    const event = evt.target.value;

    this.setState(prevState => ({
      extraSearch: {
        ...prevState.extraSearch,
        currentKey: event
      }
    }));
  }

  updateInputCurrentValue(evt) {
    const event = evt.target.value;

    this.setState(prevState => ({
      extraSearch: {
        ...prevState.extraSearch,
        currentValue: event
      }
    }));
  }

  updateTable = () => {
    const { currentKey, currentValue } = this.state.extraSearch;
    
    if(!currentKey || currentKey.trim().length === 0 || !currentValue || currentValue.trim().length === 0){
      handleError('Error', 'Key and Value must be both populated!');
    } else {
      this.fetchData(this.table.current.state);
    }
  }

  resetExtraSearchFields = () => {
    this.setState(prevState => ({
      extraSearch: {
        ...prevState.extraSearch,
        currentKey: '',
        currentValue: ''
      }
    }), () => {this.fetchData(this.table.current.state);})
  }

  render() {
    const { data, pages, loading } = this.state;
    const { adminSamplesPage,
      adminSamplesPageSize,
      adminSamplesFilters,
      adminSamplesSorting } = this.props.sandbox;
    const { group_name } = this.props.auth;
    return (
      <Container fluid>
        <Dialog ref={component => { this.dialog = component }} />
        {this.renderExtraInfo()}
        {this.renderFixClassificationModal()}
        {this.renderSampleSubmissionsList()}

        <Row>
          <Col sm="7">
            <h3>Sandbox Samples</h3>
          </Col>
        </Row>
        
        <ReactTable
          columns={[
            {
              Header: "Filename",
              id: "filename",
              filterable: false,
              sortable: false,
              accessor: d => <Link to={`/sandbox/report/${d.sha512}/`}>{d.filename}</Link>
            },
            {
              Header: "MD5",
              id: "md5",
              accessor: "md5",
              minWidth: 280,
              maxWidth: 280,
              filterable: false,
              sortable: false
            },
            {
              Header: "Size",
              id: "file_size",
              accessor: d => filesize(d.file_size),
              filterable: false,
              maxWidth: 100,
              minWidth: 100
            },
            {
              Header: "Format",
              id: "format",
              accessor: d => d.format === d.ext ? d.format : `${d.format} (${d.ext})`,
              className: 'centeredCell',
              maxWidth: 120,
              minWidth: 120,
              resizable: false,
              sortable: false,
              Filter:  ({ filter, onChange }) =>
              <>
                <select
                  className={style.doubleFilter}
                  onChange={event => onChange(`${event.target.value}|${this.extensionFilter.current.value}`)}
                  ref={this.formatFilter}
                  value={filter ? filter.value.split("|")[0] : ""}
                >
                  <option value="">FORMAT</option>
                  {supportedFormats.map(d => <option key={d} value={d}>{d}</option>)}
                </select>
                <select
                  className={style.doubleFilter}
                  onChange={event => onChange(`${this.formatFilter.current.value}|${event.target.value}`)}
                  ref={this.extensionFilter}
                  value={filter ? filter.value.split("|")[1] : ""}
                >
                  <option value="">EXTENSION</option>
                  {supportedExtensions.map(d => <option key={d} value={d}>{d}</option>)}
                </select>
              </>
            },
            {
              Header: "Last submission",
              id: "last_submission",
              accessor: d => localizeDate(d.last_submission),
              resizable: false,
              minWidth: 150,
              maxWidth: 150,
              Filter: ({ filter, onChange }) => <>
                <DateRangePicker
                  onApply={(_event, picker) => {
                    const startDate = picker.startDate.format('YYYY-MM-DD');
                    const endDate = picker.endDate.format('YYYY-MM-DD');

                    onChange(`${startDate}|${endDate}`);
                  }}

                  onCancel={() => onChange("")}
                >
                  <button className={style.timePickerButton}>
                    <FontAwesomeIcon
                      className={style.actionIcon}
                      icon={faCalendar}
                      title="Toggle filter"
                    />
                  </button>
                </DateRangePicker>
                {filter && <span className={style.resetRangeDate} onClick={() => onChange("")}>RESET</span>}
                <p className={style.rangeDate}>from: {filter ? filter.value.split("|")[0] : ""}</p>
                <p className={style.rangeDate}>to: {filter ? filter.value.split("|")[1] : ""}</p>
              </>
            },
            {
              Header: "Last scan",
              id: "last_scan",
              accessor: d => localizeDate(d.last_scan),
              resizable: false,
              minWidth: 150,
              maxWidth: 150,
              Filter: ({ filter, onChange }) => <>
                <DateRangePicker
                  onApply={(_event, picker) => {
                    const startDate = picker.startDate.format('YYYY-MM-DD');
                    const endDate = picker.endDate.format('YYYY-MM-DD');

                    onChange(`${startDate}|${endDate}`);
                  }}

                  onCancel={() => onChange("")}
                >
                  <button className={style.timePickerButton}>
                    <FontAwesomeIcon
                      className={style.actionIcon}
                      icon={faCalendar}
                      title="Toggle filter"
                    />
                  </button>
                </DateRangePicker>
                {filter && <span className={style.resetRangeDate} onClick={() => onChange("")}>RESET</span>}
                <p className={style.rangeDate}>from: {filter ? filter.value.split("|")[0] : ""}</p>
                <p className={style.rangeDate}>to: {filter ? filter.value.split("|")[1] : ""}</p>
              </>
            },
            {
              Header: "Status",
              id: "status",
              resizable: false,
              sortable: false,
              className: 'centeredCell',
              minWidth: 120,
              maxWidth: 120,
              accessor: d => <DBadge type="status" value={d.status} />,
              Filter: ({ filter, onChange }) =>
                    <select
                      onChange={event => onChange(event.target.value)}
                      className={style.selectFullHeight}
                      value={filter ? filter.value : ""}
                    >
                      <option value=""></option>
                      {submissionStatus.map(d => {
                        if (d !== unsupportedStatus || [qaGroup, adminGroup].includes(group_name)) {
                          return <option key={d} value={d}>{d}</option>
                        } else {
                          return null;
                        }
                      })}
                    </select>
            },
            {
              Header: "Platforms",
              id: "platforms",
              resizable: false,
              sortable: false,
              minWidth: 120,
              maxWidth: 120,
              className: 'centeredCell',
              accessor: d => d.dynamic_analyses.map((p, idx) => <PlatformStatus md5={d.md5} platform={p.platform} status={p.status} key={idx} />),
              Filter:  ({ filter, onChange }) =>
              <>
                <select
                  className={style.doubleFilter}
                  onChange={event => onChange(`${event.target.value}|${this.platformResult.current.value}`)}
                  ref={this.platformFilter}
                  value={filter ? filter.value.split("|")[0] : ""}
                >
                  <option value="">STATUS</option>
                  { platformStatus.map(d => <option key={d} value={d}>{d}</option>)}
                </select>
                <select
                  className={style.doubleFilter}
                  onChange={event => onChange(`${this.platformFilter.current.value}|${event.target.value}`)}
                  ref={this.platformResult}
                  value={filter ? filter.value.split("|")[1] : ""}
                >
                  <option value="">PLATFORM</option>
                  {Object.keys(OSnames).map(d => <option key={d} value={d}>{d}</option>)}
                </select>
              </>
            },
            {
              Header: "Result",
              id: "result",
              accessor: d => d.result ? <ResultRuleCounter result={d.result} rules={d.rules} idx={d.md5} /> : '',
              Filter: ({ filter, onChange }) =>{
                    return <select
                      onChange={event => onChange(event.target.value)}
                      className={style.selectFullHeight}
                      value={filter ? filter.value : ""}
                    >
                      <option value=""></option>
                      {submissionResults.map(d => <option key={d} value={d}>{d}</option>)}
                    </select>},
              resizable: false,
              sortable: false,
              maxWidth: 100,
              minWidth: 100,
              className: 'centeredCell'
            },
            {
              Header: "Actions",
              id: "actions",
              accessor: d => <>
                <FontAwesomeIcon
                  className={style.actionIcon}
                  icon={faDownload}
                  onClick={() => this.downloadSample(d.md5)}
                  title="Download sample"
                />
                {d.status === analysisCompleted && <FontAwesomeIcon
                  className={style.actionIcon}
                  icon={faRedo}
                  onClick={() => this.startRescan(d.md5)}
                  title="Rescan sample"
                />}
                {(d.status === analysisFailed || d.status === analysisCompleted) && <FontAwesomeIcon
                  className={style.actionIcon}
                  icon={faSlidersH}
                  onClick={() => {
                    this.setState({
                      modalFixClassification: {
                        visible: true,
                        tempFixed: d.fixed_classification,
                        tempClassification: d.result,
                        sha512: d.sha512,
                        rescanAfterFixedClassification: false
                      }
                    });
                  }}
                  title="Fix sample classification"
                />}
                <FontAwesomeIcon
                  className={style.actionIcon}
                  icon={faListOl}
                  onClick={() => {
                    this.setState({
                      modalSampleSubmissionsList: {
                        visible: true,
                        hash: d.sha512,
                        data: [],
                        pages: null,
                        loading: true
                      }
                    })
                  }}
                  title="Show submissions"
                />
              </>,
              filterable: false,
              sortable: false,
              resizable: false,
              className: 'centeredCell',
              minWidth: 150,
              maxWidth: 150
            }
          ]}
          manual
          minRows="3"
          data={data}
          pages={pages}
          loading={loading}
          ref={this.table}
          onFetchData={this.fetchData}
          defaultPageSize={adminSamplesPageSize}
          pageSizeOptions={[25, 50, 100]}
          className="-striped -highlight"
          filterable
          defaultPage={adminSamplesPage - 1}
          defaultFiltered={adminSamplesFilters}
          defaultSorted={adminSamplesSorting}
        />
        <p className={style.pleaseUseFilters}>Only the first 10.000 results are retrieved. Please use filters to narrow the result.</p>
      </Container>
    );
  }
};

export default connect(
  state => ({
    sandbox: state.sandbox,
    auth: state.auth
  }),
  dispatch => ({
    updateAdminSamplesPageSize: data => dispatch(updateAdminSamplesPageSize(data)),
    updateAdminSamplesTablePage: data => dispatch(updateAdminSamplesTablePage(data)),
    updateAdminSamplesFilters: data => dispatch(updateAdminSamplesFilters(data)),
    updateAdminSamplesSorting: data => dispatch(updateAdminSamplesSorting(data))
  })
)(SandboxSamples);
